module.exports = __webpack_public_path__ + "static/media/img-02.8ab4e499.jpg";